import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Badge, Box, Grid, Typography } from '@kc-console/common-ui';
import { SpriteImgIcon } from '@kc-console/shared-ui';

import { getBadgeColor, getBadgeVariant } from '../../lib/serviceBadgePresentation';

import type { ServiceBadge } from '@kc-console/context';
import type { LnbContainerProps } from './types';

export interface LnbServiceTitleProps {
  keyword: string;
  name: string;
  targetLnbBadges: ServiceBadge[];
  collapsed?: boolean;
}

export default function LnbServiceTitle({
  collapsed,
  keyword,
  name,
  targetLnbBadges,
}: LnbServiceTitleProps) {
  return (
    <LnbServiceTitleContainer collapsed={collapsed} container>
      <SpriteImgIcon fontSize={24} id={keyword} category={'BeyondServiceRegular'} />
      {!collapsed ? (
        <>
          <LnbServiceTitleText variant="label/medium/xl">{name}</LnbServiceTitleText>
          <LnbServiceBadgeListContainer>
            {targetLnbBadges.map(badge => (
              <Badge
                key={badge.id}
                label={badge.name}
                color={getBadgeColor(badge.type, badge.name)}
                variant={getBadgeVariant(badge.type)}
                shape="rectangular"
              />
            ))}
          </LnbServiceBadgeListContainer>
        </>
      ) : null}
    </LnbServiceTitleContainer>
  );
}

const LnbServiceTitleContainer = styled(Grid, {
  shouldForwardProp: prop => prop !== 'collapsed',
})<LnbContainerProps>`
  align-items: center;
  gap: 8px;
  height: 64px;
  padding: 8px 20px 0;

  ${({ collapsed }) =>
    collapsed &&
    css`
      padding: 8px 16px 0;
    `}
`;

const LnbServiceTitleText = styled(Typography)`
  white-space: pre-line;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;

  color: ${({ theme }) => theme.color['text/default']};
`;

const LnbServiceBadgeListContainer = styled(Box)`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-left: 4px;
`;
